(() => {
  const reveal = (root = document) => {
    const items = root.querySelectorAll('[data-digi-reveal]:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    items.forEach((item) => observer.observe(item));
  };

  const initMoments = (section) => {
    if (!section || section.dataset.digiInitialized === 'true') return;
    section.dataset.digiInitialized = 'true';

    const moments = [...section.querySelectorAll('[data-digi-moment]')];
    const grid = section.querySelector('.digi-awareness__moment-grid');
    const result = section.querySelector('[data-digi-result]');
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    let activeMoment = null;

    const placeResult = () => {
      if (!result || !grid || !activeMoment) return;

      if (mobileQuery.matches) {
        activeMoment.insertAdjacentElement('afterend', result);
        result.classList.add('is-inline');
      } else {
        grid.insertAdjacentElement('afterend', result);
        result.classList.remove('is-inline');
      }
    };

    const updateResult = (moment, shouldScroll = false) => {
      if (!moment || !result) return;
      activeMoment = moment;

      moments.forEach((item) => {
        const active = item === moment;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      const values = {
        '[data-digi-result-label]': moment.dataset.label,
        '[data-digi-result-title]': moment.dataset.title,
        '[data-digi-result-text]': moment.dataset.text,
        '[data-digi-result-cta]': moment.dataset.cta
      };

      Object.entries(values).forEach(([selector, value]) => {
        const node = result.querySelector(selector);
        if (node && value) node.textContent = value;
      });

      const link = result.querySelector('[data-digi-result-link]');
      if (link) link.href = moment.dataset.link || '#digi-awareness-universe';

      const image = result.querySelector('[data-digi-result-image]');
      if (image) {
        const imageUrl = moment.dataset.image || '';
        image.hidden = !imageUrl;
        if (imageUrl) image.src = imageUrl;
        else image.removeAttribute('src');
      }

      placeResult();
      result.hidden = false;
      result.animate(
        [{ opacity: .45, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 360, easing: 'ease-out' }
      );

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'digi_awareness_moment_selected',
        awareness_moment: moment.dataset.title || ''
      });

      if (shouldScroll) {
        window.setTimeout(() => {
          result.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 80);
      }
    };

    const closeResult = () => {
      if (!result || !grid || !activeMoment) return;

      moments.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });

      result.hidden = true;
      result.classList.remove('is-inline');
      grid.insertAdjacentElement('afterend', result);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'digi_awareness_moment_closed',
        awareness_moment: activeMoment.dataset.title || ''
      });

      activeMoment = null;
    };

    moments.forEach((moment) => {
      moment.addEventListener('click', () => {
        const isOpen = activeMoment === moment && !result.hidden;
        if (isOpen) {
          closeResult();
          return;
        }

        updateResult(moment, true);
      });
    });

    const syncPlacement = () => {
      if (activeMoment && !result.hidden) placeResult();
    };

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', syncPlacement);
    } else {
      mobileQuery.addListener(syncPlacement);
    }

    const scenario = new URLSearchParams(window.location.search).get('scenario');
    const initial = scenario
      ? moments.find((moment) => (moment.dataset.title || '').toLowerCase().includes(scenario.toLowerCase()))
      : null;

    if (initial) updateResult(initial);
  };

  const initHero = (hero) => {

    if (!hero || hero.dataset.digiInitialized === 'true') return;

    hero.dataset.digiInitialized = 'true';

    const campaignKey = hero.dataset.campaignKey || '';
    const heroCta = hero.querySelector('[data-digi-awareness-hero-cta]');

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'digi_awareness_view',
      awareness_campaign_key: campaignKey
    });

    heroCta?.addEventListener('click', () => {

      if (heroCta.dataset.digiAwarenessTracked === 'true') return;

      heroCta.dataset.digiAwarenessTracked = 'true';

      window.dataLayer.push({
        event: 'LP_Awareness',
        event_category: 'awareness',
        event_action: 'click',
        event_label: 'descobrir_minha_salvacao',
        page_type: 'landing_page_awareness',
        cta_location: 'awareness_hero',
        awareness_campaign_key: campaignKey
      });

    });

  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-digi-awareness-hero]').forEach(initHero);
    root.querySelectorAll('[data-digi-awareness-moments]').forEach(initMoments);
    reveal(root);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll()); else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
